import { THEME } from '@common/constants/theme.constant';
import React from 'react';
import { css } from 'twin.macro';
import { IFieldV2Props } from './field-v2.component';

export interface IFieldLabelV2Props {
    label?: IFieldV2Props<unknown>['label'];
    required?: IFieldV2Props<unknown>['required'];
    htmlFor?: string;
    className?: string;
    onLabelClick?: () => void;
}

export const FieldLabelV2 = ({
    label,
    required,
    className,
    htmlFor,
    onLabelClick,
}: IFieldLabelV2Props): JSX.Element | null => {
    return (
        <label onClick={onLabelClick} htmlFor={htmlFor} css={styles.root} className={className}>
            {label}
            {required && <span css={styles.required}>Required</span>}
        </label>
    );
};
const styles = {
    root: css`
        display: flex;
        justify-content: space-between;
        width: 100%;
        gap: 8px;
        line-height: 24px;
        align-items: center;
        font-size: ${THEME.BASE_FONT_SIZE};
        font-weight: 400;
        color: ${THEME.TEXT_BLACK};
        max-width: 100%;
    `,
    required: css`
        color: ${THEME.GRAY};
        font-size: ${THEME.SMALL_FONT_SIZE};
        font-weight: 300;
    `,
};
